const CASAMENTO_CIVIL = 'Casamento Civil'
const CASAMENTO_RELIGIOSO = 'Casamento Religioso com efeito civil'
const UNIAO_ESTAVEL = 'Conversão de união estável em casamento'
const EDITAL_OUTRA_SERVENTIA = 'Afixação de edital de outra serventia'
const A_VISTA_HABILITACAO = 'Registro de Casamento à vista de Habilitação'
const CASAMENTO_RELIGIOSO_EFEITO_CIVIL = 'Religioso com efeito civil com Habilitação posterior'
const CASAMENTO_CIVIL_OUTRO_CARTORIO = 'Casamento Civil em outro cartório'
const CASAMENTO_CIVIL_POR_DILIGENCIA = "Casamento Civil por diligência"

const tipos = [
  CASAMENTO_CIVIL,
  CASAMENTO_CIVIL_POR_DILIGENCIA,
  CASAMENTO_RELIGIOSO,
  UNIAO_ESTAVEL,
  EDITAL_OUTRA_SERVENTIA,
  A_VISTA_HABILITACAO,
  CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
  CASAMENTO_CIVIL_OUTRO_CARTORIO
]

export {
  tipos,
  CASAMENTO_CIVIL,
  CASAMENTO_CIVIL_POR_DILIGENCIA,
  CASAMENTO_RELIGIOSO,
  EDITAL_OUTRA_SERVENTIA,
  CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
  A_VISTA_HABILITACAO,
  CASAMENTO_CIVIL_OUTRO_CARTORIO,
  UNIAO_ESTAVEL
}
